import clsx from "clsx"

function cn(...inputs) {
  return clsx(inputs)
}

export { cn }
